export const PUSH_NOTIFICATION_SYNC_USER_ID_KEY = "PUSH_NOTIFICATION_SYNC_USER_ID";
export const PUSH_NOTIFICATION_SYNC_TOKEN_KEY = "PUSH_NOTIFICATION_SYNC_TOKEN";
export const PUSH_NOTIFICATION_SYNC_ENDPOINT_KEY = "PUSH_NOTIFICATION_SYNC_ENDPOINT";
export const PUSH_NOTIFICATION_SYNC_ENDPOINT_RESAVED_AT_KEY = "PUSH_NOTIFICATION_SYNC_ENDPOINT_RESAVED_AT";
export const PUSH_NOTIFICATION_SYNC_REFRESH_KEY = "PUSH_NOTIFICATION_SYNC_REFRESH_VERSION";
export const PUSH_NOTIFICATION_SYNC_REFRESH_VERSION = "2026-04-27-browser-push-refresh";
const PUSH_SUBSCRIPTION_RESAVE_INTERVAL_MS = 24 * 60 * 60 * 1000;

export const hasSavedPushNotificationToken = (
	userId?: string | null,
	token?: string | null
) => {
	if (!userId || !token) return false;

	return (
		localStorage.getItem(PUSH_NOTIFICATION_SYNC_USER_ID_KEY) === userId &&
		localStorage.getItem(PUSH_NOTIFICATION_SYNC_TOKEN_KEY) === token
	);
};

export const savePushNotificationToken = (userId: string, token: string) => {
	localStorage.setItem(PUSH_NOTIFICATION_SYNC_USER_ID_KEY, userId);
	localStorage.setItem(PUSH_NOTIFICATION_SYNC_TOKEN_KEY, token);
	localStorage.setItem("NOTIFICATION_PERMISSION_STATE", "enabled");
};

export const hasSavedPushSubscription = (
	userId?: string | null,
	endpoint?: string | null
) => {
	if (!userId || !endpoint) return false;

	return (
		localStorage.getItem(PUSH_NOTIFICATION_SYNC_USER_ID_KEY) === userId &&
		localStorage.getItem(PUSH_NOTIFICATION_SYNC_ENDPOINT_KEY) === endpoint
	);
};

export const savePushSubscription = (userId: string, endpoint: string) => {
	localStorage.setItem(PUSH_NOTIFICATION_SYNC_USER_ID_KEY, userId);
	localStorage.setItem(PUSH_NOTIFICATION_SYNC_ENDPOINT_KEY, endpoint);
	localStorage.setItem(PUSH_NOTIFICATION_SYNC_ENDPOINT_RESAVED_AT_KEY, String(Date.now()));
	localStorage.setItem("NOTIFICATION_PERMISSION_STATE", "enabled");
};

export const shouldResavePushSubscription = (
	userId?: string | null,
	endpoint?: string | null,
	now = Date.now()
) => {
	if (!hasSavedPushSubscription(userId, endpoint)) return true;

	const savedAt = Number(localStorage.getItem(PUSH_NOTIFICATION_SYNC_ENDPOINT_RESAVED_AT_KEY) || 0);
	if (!Number.isFinite(savedAt) || savedAt <= 0) return true;

	return now - savedAt > PUSH_SUBSCRIPTION_RESAVE_INTERVAL_MS;
};

export const needsPushNotificationTokenRefresh = () => {
	return (
		localStorage.getItem(PUSH_NOTIFICATION_SYNC_REFRESH_KEY) !==
		PUSH_NOTIFICATION_SYNC_REFRESH_VERSION
	);
};

export const markPushNotificationTokenRefreshed = () => {
	localStorage.setItem(
		PUSH_NOTIFICATION_SYNC_REFRESH_KEY,
		PUSH_NOTIFICATION_SYNC_REFRESH_VERSION
	);
};
